import { Kostenstelle } from '../../../../types/Controlling/Kostenstelle'
import Image from '../../../UI/Image/Image'
import Upsert from './Upsert/Upsert'

type Props = { data: Kostenstelle; pullList: () => void }

const Item: React.FC<Props> = ({ data, pullList }) => {
  return (
    <div className="flex flex-col w-full gap-2 bg-white shadow-lg p-10">
      <a className="text-xl text-center group flex flex-col gap-5 justify-center" href={`/admin/controlling/${data.companyUUID}/${data.uuid}`}>
        {data.name}
        {!!data.imageKey && (
          <Image addPrefix src={data.imageKey} className="max-h-[125px] group-hover:scale-105 transition-all w-auto aspect-square" />
        )}
      </a>
      <div className="flex justify-end">
        <Upsert initData={data} pullList={pullList} />
      </div>
    </div>
  )
}

export default Item
